import { AlbumTabIcon, MusicTabIcon } from "@assets/svg";

import { CatalogTab } from "./components/utils";

export type TCatalogTab = {
  value: CatalogTab;
  label: string;
  icon: JSX.Element;
  className?: string;
};

export const catalogTabs: TCatalogTab[] = [
  {
    value: CatalogTab.TRACK,
    label: "showTracks",
    icon: <MusicTabIcon />,
    className: "track",
  },
  {
    value: CatalogTab.ALBUM,
    label: "showAlbums",
    icon: <AlbumTabIcon />,
    className: "album",
  },
];
